import { useSelector } from '@xstate5/react';

import { useEssentialMachines } from '../../EssentialMachines';

// ─────────────────────────────────────────────────────────────────────────────

export const useIsFetchingSession = () => {
  const { authMachineRef } = useEssentialMachines();

  return useSelector(authMachineRef, (state) => {
    return state.matches('fetching-session') || state.matches('retrying-session');
  });
};
